import { render, staticRenderFns } from "./MyDocumentsNavigation.vue?vue&type=template&id=b5fa6f30&scoped=true&"
import script from "./MyDocumentsNavigation.vue?vue&type=script&lang=js&"
export * from "./MyDocumentsNavigation.vue?vue&type=script&lang=js&"
import style0 from "./MyDocumentsNavigation.vue?vue&type=style&index=0&id=b5fa6f30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5fa6f30",
  null
  
)

export default component.exports